// @ts-nocheck
import React, {FC, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import {Typography} from '@mui/material';
import {Badge} from 'react-bootstrap';

interface EngineerListProps {
  isLoading: boolean;
  engineers: Engineer[];
}

export const EngineerList: FC<EngineerListProps> = ({isLoading, engineers}) => {
  const navigate = useNavigate();

  // ---------- COLUMNS ----------
  const columns = useMemo(
      () => [
        {accessorKey: 'id', header: 'ID'},
        {accessorKey: 'name', header: 'Name'},
        {accessorKey: 'role_name', header: 'Rolle'},
        {accessorKey: 'dealer_name', header: 'Dealer'},
        {
          accessorKey: 'status',
          header: 'Status',
          Cell: ({cell}) => {
            const status = cell.getValue();
            return (
              <Badge
                pill
                variant={status === '1' ? 'success' : 'warning'}
                className={
                status === '1' ?
                  'badge-soft-success' :
                  'badge-soft-warning'
                }
              >
                {status === '1' ? 'Confirmed' : 'Unconfirmed'}
              </Badge>
            );
          },
        },
      ],
      [],
  );

  // ---------- DATA ----------
  const data = useMemo(
      () =>
      isLoading ?
        [] :
        engineers.map((engineer) => ({
          id: engineer.id ?? '',
          name: `${engineer.firstname ?? ''} ${engineer.lastname ?? ''}`,
          dealer_name: engineer?.dealer?.name ?? '',
          role_name: engineer?.role?.name ?? '',
          status: engineer.status ?? '',
        })),
      [engineers, isLoading],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      enableSorting
      enableColumnFilters
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyRowProps={({row}) => ({
        onClick: () => navigate(`/member/${row.original?.id}`),
        style: {cursor: 'pointer'},
      })}
      renderTopToolbarCustomActions={() =>
        <Typography variant="h6">Members</Typography>
      }
    />
  );
};
